import React from 'react'
import { useVM } from '../../Structure/utilities/ViewModelStructure'
import { TransactionsSheetVM } from '../../Structure/ViewModels/Admin/TransactionsSheetVM'
import { Col, Container, Row } from 'react-bootstrap'
import Search from '../Utilities/Search'
import CustomSelect from '../Utilities/CustomSelect'

const TransactionsSheet = () => {
    const control = useVM<TransactionsSheetVM>(new TransactionsSheetVM())
  return (
    <Container>
    <div className='py-3'>
      <div className='d-flex py-2'>
        <div>
          <Search hasNoSelect onSearch={a=>{ control.Search = a; control.getData() }} />
        </div>
        <div className='px-1 h-100 d-flex my-auto'>
          <CustomSelect 
                clearable
                list={[{label:'تم التسليم',value:'done'},{label:'لم يتم التسليم',value:'settled'}]} 
                onSelect={a=>{control.Status=a; control.getData()  }}
            />
        </div>
        <div className='px-1 h-100 d-flex my-auto'>
          <CustomSelect 
                clearable
                list={[{label:'اشتراك',value:'اشتراك'},{label:'دفعة',value:'دفعة'}]} 
                onSelect={a=>{control.Type=a; control.getData()  }}
            />
        </div>
        <div className='px-1 h-100 d-flex my-auto'>
            <input
                className='input-field' 
                type="date" 
                value={control.From} 
                onChange={a=>{ control.From=a.target.value; control.getData() } } 
            />
        </div>
        <div className='px-1 h-100 d-flex my-auto'>
            <input
                className='input-field' 
                type="date" 
                value={control.To} 
                onChange={a=>{ control.To=a.target.value; control.getData() } } 
            />
        </div>
        {
            control.Data.length>0?(
                <div className='px-1 text-success d-flex'>
                    <div className='d-flex flex-column justify-content-center c-pointer'>
                        <div className=' text-center ' onClick={()=>control.downloadExcel()}>
                            {`->`} تحميل الملف
                        </div>
                    </div>
                </div>
            ):(null)
        }

      </div>
      {
        control.Show(
          <div>
            <Row className='py-4 justify-content-center'>
              <Col md='6' className='d-flex justify-content-around'>
                  <div>
                      <h4>الاجمالي</h4>
                  </div>
                  <div>
                    <h4 className='text-success'>
                      {
                          Math.floor(Number(control.Total)*100)/100
                      }
                    </h4>
                  </div>
              </Col>
            </Row>
            <div  className='overflow-x-auto' style={{ maxHeight:'70vh' }}>
              <table   className=' w-100 text-center' style={{minWidth:'500px'}}>
                <thead style={{ position:'sticky' }}>
                  <tr className='txt-color-I bg-light-gray'>
                    <th>الاسم</th>
                    <th>التخصص</th>
                    <th>المسوق</th>
                    <th>الحساب</th>
                    <th>المدفوع</th>
                    <th>سعر العملة</th>
                    <th>القيمة بالدولار</th>      
                    <th>تاريخ التحويل</th>
                    <th>حالة السداد للمسوق</th>
                    <th>النوع</th>
                    <th>مدفوعات اضافية</th>
                    <th>قيمة المدفوعات الاضافية بالدولار</th>
                    <th>ملاحظات</th>
                  </tr>
                </thead>
                <tbody className='w-100'>
                  {
                  control.Data.map((item,index)=>(
                      <tr key={index} style={{background:index%2?'white':'rgba(200,200,200,0.2)'}}>
                          <td className='text-center'>{item.arabic_name}</td>
                          <td className='text-center'>{item.level_specialization_name}</td>
                          <td className='text-center'>{item.marketer_name}</td>
                          <td className='text-center'>{item.account_name}</td>
                          <td className='text-center'>{item.value}</td>
                          <td className='text-center'>{item.currencyPrice}</td>
                          <td className='text-center'>{item.paid}</td>
                          <td className='text-center'>{item.date}</td>
                          <td className='text-center'>{item.is_done=='done'?'تم':'لم يتم'}</td>
                          <td className='text-center'>{item.type}</td>
                          <td className='text-center'>{item.additional_amount}</td>
                          <td className='text-center'>{Math.floor(Number(item.additional_value)*100)/100}</td>
                          <td className='text-center'>{item.notes}</td>
                      </tr>
                  ))
                  }
                </tbody>
              </table>
            </div>
          </div>
        )
      }
    </div>
  </Container>
  )
}

export default TransactionsSheet
